<h2 mat-dialog-title
  >Run CV Pipeline {{ game.homeTeam }} - {{ game.awayTeam }}</h2
>
<mat-dialog-content>
  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Collection</mat-label>
        <mat-select [(value)]="phases">
          <mat-option value="all">Time-on-Ice</mat-option>
          <mat-option value="all,detect_lines"
            >Time-on-Ice + Infer Lineup</mat-option
          >
          <mat-option value="foint">Face-Offs & Interruptions</mat-option>
          <mat-option value="tracking,identification"
            >Player Tracking</mat-option
          >
          <mat-option value="all,fieldmap_registration"
            >CV Showcase</mat-option
          >
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Period</mat-label>
        <mat-select [(value)]="periods">
          <mat-option value="all">All Periods</mat-option>
          <mat-option value="1">Period 1</mat-option>
          <mat-option value="2">Period 2</mat-option>
          <mat-option value="3">Period 3</mat-option>
          <mat-option value="4">OT 1</mat-option>
          <mat-option value="5">OT 2</mat-option>
          <mat-option value="6">OT 3</mat-option>
          <mat-option value="7">OT 4</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-checkbox
        [(ngModel)]="liveMode"
        [disabled]="!hasLiveStream"
        matTooltip="Reads live stream and processes new game segments as FOINT is collected."
        >Live Mode</mat-checkbox
      >
    </div>
  </div>

  <div class="row">
    <div class="col">
      <mat-form-field>
        <mat-label>Priority</mat-label>
        <mat-select [(value)]="priority" [disabled]="liveMode"
          >Low
          <mat-option value="low">Low</mat-option>
          <mat-option value="high">High</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button [mat-dialog-close]="{}" class="close-button"
    >Cancel</button
  >
  <button
    mat-raised-button
    color="warn"
    class="sync-button"
    (click)="runPipeline()"
    >Run CV Pipeline</button
  >
</mat-dialog-actions>
